import { useEffect } from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import MessageList from '@/components/messages/MessageList';
import ChatView from '@/components/messages/ChatView';
import { useParams, useNavigate } from 'react-router-dom';
import { useMessages } from '@/hooks/useMessages';
import EmptyState from '@/components/common/EmptyState';
import Spinner from '@/components/common/Spinner';

export default function MessagesPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const { data, isLoading } = useMessages('active');

  // On desktop, auto-select the first message if none is selected
  useEffect(() => {
    if (!isMobile && !id && data && data.messages.length > 0) {
      navigate(`/app/messages/${data.messages[0].message_id}`, { replace: true });
    }
  }, [isMobile, id, data, navigate]);

  // On mobile, show either the list or the chat view
  if (isMobile) {
    if (id) {
      return <ChatView />;
    }
    return <MessageList />;
  }

  // On desktop, the sidebar handles the list; this page shows the chat view
  if (id) {
    return <ChatView />;
  }

  // While loading, show a spinner instead of the empty state to avoid a flash
  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  // No messages exist — show empty state
  return (
    <div className="flex h-full items-center justify-center">
      <EmptyState
        title="Select a conversation"
        description="Choose a message from the sidebar or start a new conversation"
        icon={
          <svg className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
        }
      />
    </div>
  );
}
